import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing icons
import AudioIcon from '@mui/icons-material/HeadphonesRounded';
import VideoIcon from '@mui/icons-material/OndemandVideo';
import { LicenseIcon } from '../icons/license-icon';
import { DownloadIcon } from '../icons/download-icon';
// Importing hooks
import { useDuration } from '../../../hooks/use-duration';
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { useMediaStore } from '../../../store/media.store';
import { usePlaylistStore } from '../../../store/playlist.store';
import { useSiteStore } from '../../../store/site.store';
// Importing 3rd party dependencies
import { Fragment } from 'react';
// Importing 3rd party components
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ----------------------------------------------------------------------
export const Playlist = () => {
    // Adding media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Adding playlist store
    const { playlist } = usePlaylistStore(useShallow((state) => ({
        playlist: state.playlist,
    })));
    // Filtering playlist for the current media element
    const currentElement = playlist === null || playlist === void 0 ? void 0 : playlist.filter((item) => item.id === (media === null || media === void 0 ? void 0 : media.id))[0];
    // Filtering playlist to remove the current media element
    const filteredPlaylist = playlist === null || playlist === void 0 ? void 0 : playlist.filter((item) => item.id !== (media === null || media === void 0 ? void 0 : media.id));
    return (_jsx(Fragment, { children: _jsxs(List, { disablePadding: true, sx: {
                backgroundColor: 'primary.main',
                color: 'white',
                maxHeight: 350,
                overflow: 'auto',
                position: 'relative',
            }, children: [currentElement && (_jsx(ListSubheader, { disableGutters: true, children: _jsx(PlaylistItem, { containerStyle: {
                            backgroundColor: 'primary.main',
                            boxShadow: 'inset 0px -30px 50px -15px rgba(0, 0, 0, 0.25)',
                            color: 'background.paper',
                        }, item: currentElement, titleVariant: "subtitle1", typeIndicator: false }) })), filteredPlaylist === null || filteredPlaylist === void 0 ? void 0 : filteredPlaylist.map((item, index) => (_jsx(PlaylistItem, { containerStyle: { cursor: 'pointer' }, divider: index < filteredPlaylist.length - 1, item: item, linked: true, titleVariant: "subtitle2" }, item.id)))] }) }));
};
const PlaylistItem = (props) => {
    // Desctructuring props
    const { containerStyle, divider = false, item, linked = false, titleVariant, typeIndicator = true, } = props;
    // Adding hooks
    const { formatDuration } = useDuration();
    // Adding media store
    const { setMedia } = useMediaStore(useShallow((state) => ({
        setMedia: state.setMedia,
    })));
    // Adding site store
    const { site } = useSiteStore(useShallow((state) => ({
        site: state.site,
    })));
    // Adding callback for playlist item click
    const handleClick = (mediaId) => {
        fetch(`${site === null || site === void 0 ? void 0 : site.url}/wp-json/media/v1/data/${mediaId}`, {
            method: 'GET',
            redirect: 'follow',
        })
            .then((response) => response.json())
            .then((mediaElement) => {
            setMedia(mediaElement);
        })
            .catch((error) => console.error(error));
    };
    return (_jsxs(ListItem, { divider: divider, sx: containerStyle, children: [typeIndicator && (_jsx(ListItemIcon, Object.assign({ sx: { color: 'white', mr: 2, minWidth: 0 } }, (linked && { onClick: () => handleClick(item.id) }), { children: item.type === 'audio' ? _jsx(AudioIcon, {}) : _jsx(VideoIcon, {}) }))), _jsx(ListItemText, Object.assign({ disableTypography: true, primary: _jsx(Typography, { noWrap: true, variant: titleVariant, children: item.title }), sx: { m: 0 } }, (linked && { onClick: () => handleClick(item.id) }))), _jsxs(Stack, { alignItems: "center", direction: "row", spacing: 1, children: [_jsx(Chip, { label: formatDuration(item.duration), size: "small", sx: {
                            backgroundColor: 'primary.main',
                            boxShadow: 'inset 0px -30px 50px -15px rgba(0, 0, 0, 0.25)',
                            color: 'background.paper',
                        } }), _jsx(LicenseIcon, { license: item.license }), _jsx(DownloadIcon, { downloadable: item.downloadable, href: item.download_link, rel: "modal:open", title: "Download" })] })] }));
};
